import { useEffect } from 'react';
import { useHubStore } from '../lib/hub.js';

// Un aviso corto arriba de todo ("Conectado a la caja principal «Caja 1»").
// Lo que pasa solo —como el enlace automático— se tiene que ver.
export default function AvisoGlobal() {
  const aviso  = useHubStore((s) => s.aviso);
  const avisar = useHubStore((s) => s.avisar);
  useEffect(() => {
    if (!aviso) return undefined;
    const t = setTimeout(() => avisar(null), 4500);
    return () => clearTimeout(t);
  }, [aviso, avisar]);
  if (!aviso) return null;
  return (
    <div role="status" style={{
      position: 'fixed', left: 12, right: 12, top: 'calc(10px + var(--safe-top))', zIndex: 2000,
      margin: '0 auto', maxWidth: 480, padding: '10px 14px', borderRadius: 12,
      background: 'var(--c-pizarra)', color: '#fff', fontSize: 14, lineHeight: 1.4,
      boxShadow: 'var(--shadow-float)', textAlign: 'center',
    }}>
      {aviso}
    </div>
  );
}
